/**
 * Destino a retomar depois do login. Usado pelo menu de aplicações: quem abre `/launch/<app>` sem
 * sessão passa pelo login e, ao entrar, segue para a aplicação escolhida em vez de cair na home.
 *
 * Só caminhos internos de `/launch/` são aceitos, para o valor guardado não virar um redirecionamento
 * para qualquer lugar.
 */
const STORAGE_KEY = "virtus_post_login_path";
const ALLOWED = /^\/launch\/[a-z0-9-]+$/;

export function rememberPostLoginPath(pathname: string): void {
  if (!ALLOWED.test(pathname)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, pathname);
  } catch {
    // sessionStorage indisponível (modo privado restrito): segue o fluxo padrão para a home.
  }
}

/**
 * Lê o destino guardado sem apagar: a leitura acontece durante a renderização, que o React pode repetir.
 * Quem chega ao destino apaga com `clearPostLoginPath()`.
 */
export function peekPostLoginPath(): string | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    return value && ALLOWED.test(value) ? value : null;
  } catch {
    return null;
  }
}

export function clearPostLoginPath(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sem sessionStorage: nada a limpar
  }
}
